import _getIterator from 'babel-runtime/core-js/get-iterator';
import _Array$from from 'babel-runtime/core-js/array/from';
import _Set from 'babel-runtime/core-js/set';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import logger from 'js-logger';

var GenericMapperFormio = function () {
  function GenericMapperFormio() {
    _classCallCheck(this, GenericMapperFormio);

    this.trueBooleanValues = ['true', 'ja', 'waar', 'j', 't', '1'];
  }

  _createClass(GenericMapperFormio, [{
    key: 'preparePolicyForFormVisualization',
    value: function preparePolicyForFormVisualization(req, form) {
      var _this = this;

      var dataObj = _Object$assign({}, req);

      // Convert string values to boolean for all convertTypes boolean
      this.converter(form, dataObj, 'boolean');

      // Cast ownRisks numeric values to strings
      _Object$keys(dataObj.ownRisks).forEach(function (ownRiskKey) {
        if (dataObj.ownRisks[ownRiskKey] !== null) {
          dataObj.ownRisks[ownRiskKey] = dataObj.ownRisks[ownRiskKey].toString();
        }
      });

      // Cast insuredAmounts numeric values to strings
      _Object$keys(dataObj.insuredAmounts).forEach(function (insuredAmountKey) {
        if (dataObj.insuredAmounts[insuredAmountKey] !== null) {
          dataObj.insuredAmounts[insuredAmountKey] = dataObj.insuredAmounts[insuredAmountKey].toString();
        }
      });

      // Reverse the mapping logic and recreate arrays for every indexed structure found in map
      this.detectIndexedFieldNames(dataObj).forEach(function (fieldName) {
        _this.convertIndexedKeysToArray(dataObj, fieldName);
      });
      return dataObj;
    }
  }, {
    key: 'detectIndexedFieldNames',
    value: function detectIndexedFieldNames(dataObj) {
      var prefixes = new _Set();
      var indexedKeyPattern = /^([A-Z]+)(?:_[A-Z0-9]+)?\[\d+\]$/;

      _Object$keys(dataObj.map || {}).forEach(function (key) {
        var match = key.match(indexedKeyPattern);
        if (match) {
          prefixes.add(match[1]);
        }
      });

      return _Array$from(prefixes);
    }
  }, {
    key: 'convertIndexedKeysToArray',
    value: function convertIndexedKeysToArray(dataObj, fieldName) {
      var array = [];
      var mapKeys = _Object$keys(dataObj.map).filter(function (key) {
        return new RegExp('^' + fieldName + '_?.*\\[\\d+\\]$').test(key);
      }); // Find keys with indexed notation

      mapKeys.forEach(function (key) {
        var match = key.match(/^(.+)\[(\d+)\]$/);
        if (match) {
          var baseKey = match[1];
          var index = parseInt(match[2], 10);

          if (!array[index]) array[index] = { map: {} };

          // Handle _CODE condition
          if (baseKey === fieldName + '_CODE') {
            if (!array[index].map[fieldName + '_CODE']) {
              array[index].map[fieldName + '_CODE'] = {};
            }
            array[index].map[fieldName + '_CODE'][dataObj.map[key]] = true;
          } else {
            array[index].map[baseKey] = dataObj.map[key];
          }

          // Optionally, delete the indexed key from map
          // delete dataObj.map[key];
        }
      });

      // Add the new array back to the data object
      if (array.length > 0) {
        dataObj[fieldName] = array;
      }
      return dataObj;
    }
  }, {
    key: 'buildRequest',
    value: function buildRequest(data, form) {
      var subObj = _Object$assign({}, data);

      // remove time and timezone from date values
      if (data.map.sourceSystem === 'SUIV') {
        this.converter(form, subObj, 'SUIVDate');
      } else {
        this.converter(form, subObj, 'localDate');
      }

      // convert number to date
      if (data.asset && data.asset.constructionDate && String(data.asset.constructionDate).length >= 4) {
        subObj.asset.constructionDate = String(data.asset.constructionDate).substring(0, 4) + '-01-01';
      }

      // remove validations from object
      delete subObj.validations;

      // remove additional ids
      if (subObj.id) delete subObj.id;
      if (subObj.asset && subObj.asset.id) delete subObj.asset.id;

      return subObj;
    }
  }, {
    key: 'converter',
    value: function converter(form, dataObj, convertType) {
      var _this2 = this;

      var keysToConvert = [];

      // recursively collect all keys for conversion from the form config
      this.getKeysForConversion(form, keysToConvert, convertType);

      // collect all values to be converted
      keysToConvert.forEach(function (key) {
        var keyArray = key.split('.');
        var keyToConvertValue = dataObj; // we set a default value to be dataObj in order to prevent errors if the value is not a nested object
        var keyToConvertReference = dataObj;
        var i = 0;

        do {
          keyToConvertValue = keyToConvertValue[keyArray[i]];
          if (i === keyArray.length - 2) {
            // we need reference to the most inner object ,that`s why we are targeting the key that`s before the last one
            keyToConvertReference = keyToConvertValue;
          }
          i++;
        } while (i < keyArray.length);

        switch (convertType) {
          case 'boolean':
            if (typeof keyToConvertValue === 'string') {
              keyToConvertReference[keyArray[keyArray.length - 1]] = _this2.trueBooleanValues.includes(keyToConvertValue.toLowerCase());
            }
            break;
          case 'localDate':
            if (typeof keyToConvertValue === 'string') {
              keyToConvertReference[keyArray[keyArray.length - 1]] = keyToConvertValue.substring(0, 'YYYY-MM-DD'.length);
            }
            break;
          case 'SUIVDate':
            _this2.convertToSUIVDate(keyToConvertReference, keyArray, keyToConvertValue);
            break;
          default:
            logger.error('Unrecognised convert type in the apollonConverter of the form configurations.');
        }
      });
    }
  }, {
    key: 'convertToSUIVDate',
    value: function convertToSUIVDate(reference, keyArray, value, dateConverter) {
      try {
        if (typeof value !== 'string' || value.length === 0) return;

        var cleanedValue = value.replace(/(\d{4})-(\d{2})-(\d{2})T.*/, '$1$2$3');
        var finalKey = keyArray[keyArray.length - 1];

        if (cleanedValue.length === 8) {
          reference[finalKey] = cleanedValue;
        }
      } catch (error) {
        console.error('Error converting date: ' + error.message);
      }
    }
  }, {
    key: 'hasApollonConverter',
    value: function hasApollonConverter(form, converterType) {
      return this.traverseComponents(form.components, converterType);
    }
  }, {
    key: 'traverseComponents',
    value: function traverseComponents(components, converterType) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(components), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var component = _step.value;

          if (component.apollonConverter === converterType) {
            return true;
          }
          if (component.components && component.components.length > 0) {
            if (this.traverseComponents(component.components, converterType)) {
              return true;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    }
  }, {
    key: 'getKeysForConversion',
    value: function getKeysForConversion(obj, keysToConvert, convertType) {
      var childObj = obj.components !== undefined && obj.components !== null ? obj.components : obj.columns;
      for (var i in childObj) {
        if (childObj[i] && childObj[i].apollonConverter != null && childObj[i].apollonConverter === convertType) {
          keysToConvert.push(childObj[i].key);
          continue;
        }

        if (childObj[i]) {
          this.getKeysForConversion(childObj[i], keysToConvert, convertType);
        }
      }
    }
  }]);

  return GenericMapperFormio;
}();

export default GenericMapperFormio;


// WEBPACK FOOTER //
// ./src/service/mapper/GenericMapperFormio.js